import FlexibleLink from '../../../util/FlexibleLink';
import { RepProjectPanel, ProjectPublishingStage } from '@platform/client/schemas';

interface EmptyProjectIntroductionPanelProps {
  projectData: RepProjectPanel;
}

const EmptyProjectIntroductionPanel = (props: EmptyProjectIntroductionPanelProps) => {
  const { projectData } = { ...props };

  const { project } = { ...projectData };
  const { publishingStage } = { ...project };

  if (publishingStage === ProjectPublishingStage.review) {
    return (
      <div className='text-center font-medium text-sm py-2'>
        This project is under review, we will let you know when it's published
      </div>
    );
  } else if (publishingStage === ProjectPublishingStage.revision_requested) {
    return (
      <div className='text-center font-medium text-sm py-2'>
        Your project needs edits before it can be published. Check your email for details and edit
        your project.
      </div>
    );
  } else if (
    publishingStage === ProjectPublishingStage.unpublished ||
    publishingStage === ProjectPublishingStage.draft
  ) {
    return (
      <div className='text-center font-medium text-sm py-2'>
        This project is unpublished. Publish it to start getting introductions
      </div>
    );
  }
  return (
    <div className='text-center font-medium text-sm py-2'>
      This project is published and open to introductions{' '}
      <FlexibleLink
        className='text-brand-600 underline font-normal'
        href='/browse/professional'
        type='legacy'
      >
        Find an Experteer
      </FlexibleLink>
    </div>
  );
};

export default EmptyProjectIntroductionPanel;
